import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
// Stored HTML, cleaned (#524): the texts people write (descriptions, posts, comments, messages) are shown as HTML
// (v-html), so a caller of a method could store a script. The server cleans them on save and the screens clean what
// they show (older records too) with this one list of allowed tags: what the text editor (Quill) makes. Shared by the
// server and the client (through the `api` alias).
import { FilterXSS, safeAttrValue as _safeAttrValue, escapeAttrValue, friendlyAttrValue, escapeHtml } from 'xss';
var QUILL_CLASS = /^(ql-[a-z0-9-]+\s*)+$/;
var TEXT = ['class', 'style'];
var WHITE_LIST = {
  p: TEXT,
  br: [],
  span: TEXT,
  strong: [],
  b: [],
  em: [],
  i: [],
  u: [],
  s: [],
  sub: [],
  sup: [],
  h1: TEXT,
  h2: TEXT,
  h3: TEXT,
  blockquote: TEXT,
  pre: TEXT,
  ol: TEXT,
  // Quill's check list: <ul data-checked="true|false">
  ul: TEXT.concat(['data-checked']),
  li: TEXT,
  a: ['href', 'target', 'rel', 'title'],
  img: ['src', 'alt', 'width', 'height']
};
var filter = new FilterXSS({
  whiteList: WHITE_LIST,
  // script and style go with their content
  stripIgnoreTagBody: ['script', 'style'],
  // other tags not on the list go (their text stays); a "<" that starts no tag ("a < b", "<3") stays as text
  onIgnoreTag: function onIgnoreTag(tag, html) {
    return /^<\/?[a-z]/i.test(html) ? '' : escapeHtml(html);
  },
  onTagAttr: function onTagAttr(tag, name, value) {
    // the editor's alignment and indent classes only, on the tags that may have a class
    if (name === 'class') return WHITE_LIST[tag].includes('class') && QUILL_CLASS.test(value) ? 'class="' + value + '"' : '';
    return undefined;
  },
  safeAttrValue: function safeAttrValue(tag, name, value, cssFilter) {
    // a link typed without a scheme (www.example.nl), as the editor keeps it: no scheme, nothing that could run
    // (read as the browser will: entities decoded, invisible characters gone, so "javascript&#58;" has its colon)
    var plain = tag === 'a' && name === 'href' ? friendlyAttrValue(value).trim() : '';
    if (plain && plain.indexOf(':') < 0) return escapeAttrValue(plain);
    return _safeAttrValue(tag, name, value, cssFilter);
  }
}); // The texts typed in the editor are cleaned when they are saved and when they are shown. Plain texts (a community's
// or an area's description, a poll's question) are only cleaned where they are shown as HTML: cleaning on save would
// store "a < b" as "a &lt; b", which the forms and the {{ }} places then show as written.
// a text as HTML that runs nothing: allowed tags and attributes only, no event handlers, no javascript: links.
// Anything but a string (an old record without the field) comes back as it is.

export var cleanHtml = function cleanHtml(html) {
  return typeof html === 'string' ? filter.process(html) : html;
}; // a plain text put into HTML (an e-mail template's $MEETING_TITLE, #18): its characters as text, also inside an attribute

var ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
export var escapeText = function escapeText(text) {
  return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
    return ENTITIES[c];
  });
};